import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCcw03 = function RefreshCcw03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 2s.8492.1213 4.364 3.636c3.5147 3.5148 3.5147 9.2132 0 12.728-1.2453 1.2452-2.7647 2.0493-4.364 2.4122M14 2h6m-6 0v6m-4 13.9998s-.8492-.1213-4.364-3.636c-3.5147-3.5148-3.5147-9.2132 0-12.728C6.8813 4.3906 8.4007 3.5865 10 3.2236m0 18.7762L4 22m6-.0002V16"
    })
  }));
};
export default RefreshCcw03;